import { FC } from 'react';
import dynamic from 'next/dynamic';
import { megaNav, newsletterCopy, siteIntegrityGroup, socialsGroup } from './types';
import FooterBottom from './footer-bottom';
import FooterMegaNav from './footer-meganav';

export interface AmplienceFooterProps {
  megaNav: megaNav;
  newsletterCopy: newsletterCopy;
  socialsGroup: socialsGroup[];
  siteIntegrityGroup: siteIntegrityGroup[];
}

const FooterNewsletterSignup = dynamic(() => import('./footer-newsletter-signup'));

const AmplienceFooter: FC<AmplienceFooterProps> = ({ newsletterCopy, socialsGroup, megaNav, siteIntegrityGroup }) => {
  return (
    <div data-testid="amplience-footer">
      <div className="py-5" style={{ backgroundColor: '#EFEEE4' }}>
        <FooterNewsletterSignup newsLetterCopy={newsletterCopy} socialsGroup={socialsGroup} />
      </div>
      <FooterMegaNav megaNav={megaNav} />
      <FooterBottom siteIntegrityGroup={siteIntegrityGroup} />
    </div>
  );
};
export default AmplienceFooter;
